import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import isCurrency from 'validator/es/lib/isCurrency';

export function currencyValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const controlValue = control.value?.toString();

        if (controlValue?.length) {
            const isValueCurrency = isCurrency(controlValue, {
                digits_after_decimal: [1, 2],
            });

            return isValueCurrency ? null : { currency: true };
        }
    };
}
